module.exports = "pegasus/assets/theme2/medium/8.jpg";